import { configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import de from '@vee-validate/i18n/dist/locale/de.json'
import en from '@vee-validate/i18n/dist/locale/en.json'

export default defineNuxtPlugin(() => {
  configure({
    generateMessage: localize({ de, en }),
  })
})
